import type { InputMaybe, Scalars } from '../scalars';
import type {
  CodingConfigUnionInput,
  PrintSettingsInput,
  SectionInput,
} from '../gql/graphql';

/** Report Input */
export class ReportInput {
  /** Report's id */
  readonly _id?: InputMaybe<Scalars['Id']['input']>;
  /** Report's coding config */
  readonly codingConfig: CodingConfigUnionInput;
  /** Report's print settings */
  readonly printSettings: PrintSettingsInput;
  /** Report's template id */
  readonly templateId: Scalars['Id']['input'];
  /** Report's title */
  readonly title: Scalars['NonEmptyString']['input'];
  /** Report's virtual root */
  readonly virtualRoot: SectionInput;
}
